import { getAccountType, getAuthItem } from "./authStorage";

export const PLATFORM_COMPANY_NAME = "Tumma Technologies";
export const TUMMA_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/tummatech-profile-pic-nobg.png`;
function readJson(key) {
  try {
    const raw = getAuthItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const firstText = (...values) =>
  values.map((v) => (v == null ? "" : String(v).trim())).find(Boolean) || "";

/** "Tumma Technologies" -> "TUMMA OFFICE". */
function withOffice({ name, logo }) {
  const companyWord = name.split(/\s+/)[0].toUpperCase();
  return { name, logo, companyWord, officeName: `${companyWord} OFFICE` };
}

/**
 * Signed-in business: the client company in the portal, else the session tenant, else Tumma.
 * ``officeName`` is the first word of the company plus OFFICE.
 */
export function resolveBrand() {
  const user = readJson("user");
  const client = getAccountType() === "client" ? readJson("client") : null;
  const tenant = readJson("tenant");

  if (client) {
    const name = firstText(
      client.Company_Name,
      client.company_name,
      client.Display_Name,
      client.display_name,
      client.name
    );
    const logo = firstText(
      client.Logo_Url,
      client.logo_url,
      client.Company_Logo,
      client.company_logo,
      client.logo
    );
    if (name) return withOffice({ name, logo });
  }

  const userLogo = firstText(user?.company_logo, user?.Company_Logo, user?.logo_url, user?.Logo_Url);
  if (tenant && !tenant.Is_Platform) {
    const name = firstText(tenant.Company_Name, user?.company_name, user?.Company_Name);
    if (name) return withOffice({ name, logo: userLogo });
  }

  return withOffice({ name: PLATFORM_COMPANY_NAME, logo: userLogo });
}
